import React from "react";
import { useState, useEffect } from "react";
import * as AppConfig from '../../../app/config/constants'

export function extractFeeText(charge) {
  if (charge === null || charge.total_cost === null) return "Rate not published";
  return (
    charge?.total_cost?.human_readable ||
    charge?.total_cost?.percentage + "% of billed charges"
  );
}

export function extractCashPrice(additionalInfo) {
  if (!additionalInfo || !additionalInfo[0]?.estimated_cost?.out_of_pocket_cost) {
    return null;
  }
  return (
  <span style={{ color: "#018077" }}>
    { " • " + additionalInfo[0].estimated_cost.out_of_pocket_cost.human_readable }
  </span>
  );
}

export function renderEstimatedCost(costType, estimate) {
  // Define the labels for each cost type
  const labels = {
    insurance_coverage: "Est. Insurance",
    out_of_pocket_cost: "Est. Out of Pocket"
  };

  // Access the cost information based on the costType argument
  const costInfo = estimate
    ?.estimated_cost
    ?.[costType]
    ?.human_readable;

  // Conditionally render the label and cost information
  if (costInfo) {
    return (
      <>
        <b>{labels[costType]}: </b>
        {costInfo}
        <br/>
      </>
    );
  }
  return null; // Return null if there's no cost information to render
}

export async function handleAPIFetch(relativeURL, apiKey) {
  const baseURL = AppConfig.COST_ESTIMATE_API_BASE_URI;
  try {
    const response = await fetch(baseURL + relativeURL, {
      headers: {
        "x-api-key": apiKey,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

export default function useFuzzySearchQueryHandler(
  apiEndpoint,
  stateUpdate,
  dataType,
  apiKey
) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (query.length >= 3) {
      handleAPIFetch(`${apiEndpoint}?query=${query}`, apiKey)
        .then((data) => {
          const new_data = {};
          const code_attribute = dataType === "services" ? "billing_code" : "taxonomy_code"
          data[dataType].forEach((item) => {
            const label = item.display
            const code = item[code_attribute];
            const extended_label = `${label} (#${code})`
            new_data[extended_label] = code
          });
          stateUpdate(new_data);
        })
        .catch((error) => console.error(`Error fetching ${dataType}:`, error));
    }
  }, [query, apiEndpoint, dataType, apiKey, stateUpdate]);

  return (event) => {
    setQuery(event.target.value);
  };
}
